import type { BryqEntry } from '../../services/bryqApi';
import { COLORS } from './format';

/**
 * The 🧠 Bryq chip, next to 📝 on every candidate card. Its colour is the candidate's Bryq state:
 *  - grey "🧠 Bryq"   — no test yet; click to send one as a filter step,
 *  - amber "🧠 sent"  — sent, result outstanding,
 *  - green "🧠 58%"   — completed (the score Bryq wrote back to Lever).
 * With several tests, the newest one decides. The chip renders nothing outside a BryqProvider.
 */
export function chipLook(entries: BryqEntry[]): { label: string; bg: string; text: string; title: string } {
  const latest = entries[0];
  if (!latest) return { label: '🧠 Bryq', bg: COLORS.cotton, text: '#767676', title: 'Send a Bryq assessment' };
  const all = entries
    .map((e) => `${e.label}: ${e.state === 'completed' ? `done${e.score !== null ? ` · ${e.score}%` : ''}` : 'outstanding'}`)
    .join('\n');
  if (latest.state === 'completed') {
    return {
      label: latest.score !== null ? `🧠 ${latest.score}%` : '🧠 done',
      bg: COLORS.greenBg,
      text: COLORS.greenText,
      title: all,
    };
  }
  return { label: '🧠 sent', bg: COLORS.orangeBg, text: COLORS.orangeText, title: all };
}


/** An outstanding Bryq turns amber after this many days, red after BRYQ_OVERDUE_DAYS. */
export const BRYQ_LATE_DAYS = 3;
export const BRYQ_OVERDUE_DAYS = 7;
